(() => {
  if (customElements.get('sown-ingredient-checker')) return;
  class IngredientChecker extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.result = this.querySelector('[data-result]');
      this.status = this.querySelector('[data-status]');
      this.input = this.querySelector('[data-ingredients]');
      this.error = this.querySelector('[data-error]');
      this.product = this.querySelector('[data-product]');
      this.tabs = [...this.querySelectorAll('[data-tab]')];
      if (!window.SownIngredientScanner || !window.SownIngredientProducts) {
        this.status.textContent = this.copy.the_checker_could_not_load_refresh_this_page_to_try_again;
        return;
      }
      this.querySelectorAll('button:disabled,select:disabled,textarea:disabled').forEach(el => { el.disabled = false; });
      this.status.textContent = '';
      [...window.SownIngredientProducts].sort((a,b) => a.brand.localeCompare(b.brand)).forEach(item => {
        const option = document.createElement('option');
        option.value = item.id;
        option.textContent = item.brand + (item.product ? ' · ' + item.product : '');
        this.product.append(option);
      });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
        tab.addEventListener('keydown', event => {
          const keys = ['ArrowLeft','ArrowRight','Home','End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.switchTab(this.tabs[next].dataset.tab);
          this.tabs[next].focus();
        });
      });
      this.product.addEventListener('change', () => this.showProduct());
      this.input.addEventListener('input', () => this.clear());
      this.querySelector('[data-scan-form]').addEventListener('submit', event => {
        event.preventDefault();
        this.scan();
      });
    }
    clear() {
      this.result.replaceChildren();
      this.result.hidden = true;
      this.status.textContent = '';
      this.error.textContent = '';
      this.input.removeAttribute('aria-invalid');
    }
    switchTab(mode) {
      this.clear();
      this.tabs.forEach(tab => {
        const active = tab.dataset.tab === mode;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== mode; });
      if (mode === 'brand' && this.product.value) this.showProduct();
    }
    add(tag, text, className) {
      const el = document.createElement(tag);
      el.textContent = text;
      if (className) el.className = className;
      this.result.append(el);
      return el;
    }
    showProduct() {
      this.clear();
      const item = window.SownIngredientProducts.find(product => product.id === this.product.value);
      if (!item) return;
      this.add('p', item.brand + (item.product ? ' · ' + item.product : ''), 'sic__fine');
      const title = item.status === 'pending' ? this.copy.formula_details_pending : item.status === 'identified' ? this.copy.prostaglandin_ingredient_identified : this.copy.no_prostaglandin_ingredients_identified;
      this.add('h3', title);
      if (item.status === 'pending') {
        this.add('p', this.copy.we_have_not_completed_this_product_record_yet_paste_the_in);
        const button = this.add('button', this.copy.paste_this_product_s_ingredients, 'sic__switch');
        button.type = 'button';
        button.addEventListener('click', () => { this.switchTab('paste'); this.input.focus(); });
      } else {
        this.add('p', item.ingredients ? this.copy.contains + item.ingredients.join(', ') : this.copy.other_ingredients_in_this_formula + item.actives);
        const source = this.add('p', '', 'sic__fine');
        const link = document.createElement('a');
        link.href = item.source;
        link.textContent = this.copy.view_ingredient_source;
        source.append(link, document.createTextNode(' · ' + item.market + this.copy.checked + item.checked));
        this.add('p', this.copy.based_on_the_referenced_formula_not_every_product_from_thi, 'sic__fine');
      }
      this.result.hidden = false;
      this.status.textContent = item.brand + ': ' + title + '.';
    }
    scan() {
      this.clear();
      const text = this.input.value;
      if (text.trim().length < 3 || !/[a-z]/i.test(text) || text.length > 20000) {
        this.error.textContent = text.length > 20000 ? this.copy.this_list_is_too_long_paste_up_to_20_000_characters : this.copy.paste_an_ingredient_list_then_choose_check_ingredients;
        this.input.setAttribute('aria-invalid','true');
        this.input.focus();
        return;
      }
      try {
        const {matches} = window.SownIngredientScanner.scan(text);
        const exact = matches.filter(match => match.kind === 'exact');
        const possible = matches.filter(match => match.kind === 'possible');
        const title = exact.length ? this.copy.prostaglandin_ingredients_identified : possible.length ? this.copy.possible_matches_to_review : this.copy.no_prostaglandin_ingredients_identified;
        this.add('h3', title);
        if (matches.length) {
          const list = this.add('ul', '');
          const seen = new Set();
          matches.forEach(match => {
            const key = match.name + match.kind;
            if (seen.has(key)) return;
            seen.add(key);
            const li = document.createElement('li');
            li.textContent = match.name;
            const note = document.createElement('small');
            note.textContent = match.kind === 'exact' ? this.copy.name_identified_in_your_text : this.copy.possible_spelling_or_context_match_check_the_original_labe;
            li.append(note);
            list.append(li);
          });
          this.add('p', this.copy.in_the_text_you_pasted, 'sic__fine');
          const evidence = this.add('p', '', 'sic__matched');
          let offset = 0;
          [...matches].sort((a,b) => a.start-b.start).forEach(match => {
            if (match.start < offset) return;
            evidence.append(document.createTextNode(text.slice(offset, match.start)));
            const mark = document.createElement('mark');
            mark.dataset.kind = match.kind;
            mark.textContent = text.slice(match.start, match.end);
            evidence.append(mark);
            offset = match.end;
          });
          evidence.append(document.createTextNode(text.slice(offset)));
        } else {
          this.add('p', this.copy.no_names_on_our_reference_list_were_found_in_the_text_you);
        }
        this.add('p', this.copy.this_checks_15_names_and_family_terms_not_every_possible_c, 'sic__fine');
        this.result.hidden = false;
        this.status.textContent = title + '. ' + this.copy.match_count.replace('[exact]', exact.length).replace('[possible]', possible.length);
      } catch {
        this.status.textContent = this.copy.the_list_could_not_be_checked_try_again_with_the_ingredien;
      }
    }
  }
  customElements.define('sown-ingredient-checker', IngredientChecker);
})();
